// =====================================================================
// COMPARTIR UNA INVITACIÓN POR WHATSAPP · deuda AC-2, BOT-DOS-IDENTIDADES C4
// =====================================================================
// El diálogo «Invitación lista» ya ofrecía COPIAR el mensaje. Esto abre
// WhatsApp con ESE MISMO mensaje ya escrito, en el teléfono o la
// computadora de quien pulsa. TEGO no manda nada por WhatsApp: el enlace
// `wa.me` solo abre la aplicación, y quien pulsa decide si lo envía.
//
// UN SOLO TEXTO para los dos botones. Si el de copiar y el de WhatsApp lo
// armaran cada uno por su lado, un día dirían cosas distintas y la
// persona recibiría la versión que nadie revisó.

// El mensaje que se copia y el que se comparte.
export function mensajeDeInvitacion(enlace, codigo) {
  return `Entra a TEGO: ${enlace} — Código: ${codigo}`;
}

// El número como lo pide `wa.me`: solo dígitos y con lada de país. Un
// número de 10 dígitos es de México (se le antepone el 52); uno que ya
// trae lada se deja igual. Sin número válido devuelve '' y WhatsApp deja
// elegir a quién mandarlo.
export function numeroParaWhatsapp(telefono) {
  const digitos = String(telefono || '').replace(/\D/g, '');
  if (digitos.length === 10) return `52${digitos}`;
  if (digitos.length >= 11 && digitos.length <= 15) return digitos;
  return '';
}

// El enlace que abre WhatsApp con el mensaje ya escrito.
export function enlaceWhatsapp(texto, telefono) {
  const numero = numeroParaWhatsapp(telefono);
  return `https://wa.me/${numero}?text=${encodeURIComponent(texto)}`;
}
